import * as React from "react";
import { Channel } from "../channel/channel.mjs";
class ChannelList extends React.Component {
  BEM() {
    const classArray = ["channel-list"];
    if (this.props.align) {
      classArray.push("channel-list--" + this.props.align);
    }
    if (this.props.size) {
      classArray.push("channel-list--" + this.props.size);
    }
    if (this.props.className) {
      classArray.push(this.props.className);
    }
    return classArray.join(" ");
  }
  getChannels() {
    if (!this.props.items) {
      return null;
    }
    return this.props.items.map((channel, index) => {
      return /* @__PURE__ */ React.createElement(Channel, { ...channel, className: "channel-list__item", size: this.props.size, color: this.props.color, key: index });
    });
  }
  render() {
    return /* @__PURE__ */ React.createElement("div", { className: this.BEM() }, this.getChannels());
  }
}
export {
  ChannelList
};
